import { useState, useRef, useEffect } from 'react';
import './App.css';
import { Toaster, toast } from 'sonner';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { cropDataUrlToGoldFrame } from './components/gold/goldCapture';
import { removeBackgroundFromDataUrl } from './services/segmindGold';
import GoldEntryPage from './components/gold/GoldEntryPage';
import GoldCameraPage from './components/gold/GoldCameraPage';
import GoldResultPage from './components/gold/GoldResultPage';

function App() {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, () => {});
    return () => unsubscribe();
  }, []);

  const personUrlRef = useRef('');
  const [currentState, updateState] = useState(-1);
  const [generating, setGenerating] = useState(false);
  const [mergeData, setMergeData] = useState({});
  const [mergeError, setMergeError] = useState({});

  const handlePhotoConfirmed = (dataUrl) => {
    personUrlRef.current = dataUrl;
    runGoldProcessing();
  };

  const runGoldProcessing = async () => {
    setGenerating(true);
    setMergeError({});
    updateState(1);

    try {
      const cutoutDataUrl = await removeBackgroundFromDataUrl(
        personUrlRef.current
      );
      const framedCutout = await cropDataUrlToGoldFrame(cutoutDataUrl);
      setMergeData({ data: framedCutout });
    } catch (e) {
      console.warn('gold bg removal error', e);
      setMergeError({ message: e?.message || 'Background removal failed' });
      toast.error('Could not process your photo. Please try again.');
      updateState(0);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className="goldApp">
      {currentState === -1 && <GoldEntryPage updateState={updateState} />}
      {currentState === 0 && (
        <GoldCameraPage
          updateState={updateState}
          onPhotoConfirmed={handlePhotoConfirmed}
        />
      )}
      {currentState === 1 && (
        <GoldResultPage
          generating={generating}
          mergeError={mergeError}
          mergeData={mergeData}
          updateState={updateState}
        />
      )}
      <Toaster />
    </div>
  );
}

export default App;
